const REACT_APP_API_END_POINT = process.env.REACT_APP_API_END_POINT;
const REACT_APP_PORTAL_URL = process.env.REACT_APP_PORTAL_URL;
const REACT_APP_SITE_URL = process.env.REACT_APP_SITE_URL;

export { REACT_APP_API_END_POINT, REACT_APP_PORTAL_URL, REACT_APP_SITE_URL };
